import React from 'react';
import { useTranslation } from '../../i18n/provider';
import styles from './FoodTabs.module.css';

type FoodTab = 'info' | 'track';

type Props = {
  activeTab: FoodTab;
  onChangeTab: (tab: FoodTab) => void;
};

const FoodTabs: React.FC<Props> = ({ activeTab, onChangeTab }) => {
  const { t } = useTranslation();
  return (
    <div className={styles.tabs}>
      <button
        type="button"
        onClick={() => onChangeTab('info')}
        className={`${styles.tabButton} ${activeTab === 'info' ? styles.active : ''}`}
      >
        {t('food.tabs.info')}
      </button>
      <button
        type="button"
        onClick={() => onChangeTab('track')}
        className={`${styles.tabButton} ${activeTab === 'track' ? styles.active : ''}`}
      >
        {t('food.tabs.track')}
      </button>
    </div>
  );
};

export default FoodTabs;
